export var inAppNotificationUri = '/in-app-notifications';
export var enableInAppNotificationsUri = inAppNotificationUri + "/enabled";
export var createInAppNotificationsApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + inAppNotificationUri;
    var configureInAppNotificationUrl = "" + baseUrl + enableInAppNotificationsUri;
    return {
        getInAppNotificationSettings: function () { return http.get(apiUrl); },
        configureInAppNotification: function (dto) { return http.post(configureInAppNotificationUrl, dto); },
    };
};
//# sourceMappingURL=index.js.map